import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, throwError } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class UserService {
  private _tenantId = new BehaviorSubject<string | null>(null);
  private _activeRole = new BehaviorSubject<string | null>(null);

  tenantId$ = this._tenantId.asObservable();
  activeRole$ = this._activeRole.asObservable();

  constructor(private http: HttpClient) {}

  setTenantId(id: string | null) {
    this._tenantId.next(id);
  }

  setActiveRole(role: string | null) {
    this._activeRole.next(role);
  }

  getUserInfo() {
    const url = `${environment.keycloak.issuer}realms/${environment.keycloak.realm}/protocol/openid-connect/userinfo`;
    return this.http.get(url, { observe: "response" }).pipe(
      map((response: any) => response.body),
      catchError((error) => throwError(() => error)),
    );
  }

  getUserProfileImage() {
    const url = `${environment.keyClockApiBaseUrl}api/keycloak/v2/graph/realms/${environment.keycloak.realm}/image`;
    return this.http.get(url, { responseType: "text" });
  }
}
